import { useEffect, useState } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { IconButton, Grid, Box, Modal, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useNavigate } from "react-router-dom";
import usercalls from "../../Axios";
import consts from "../../constant";
import toast, { Toaster } from "react-hot-toast";
import { set } from "react-hook-form";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "80%", // 0px and above (mobile)
    sm: 400, // 600px and above
  },
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const BotHome = () => {
  const [show, setShow] = useState(false);
  const [verified, setVerified] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const navigate = useNavigate();
  const secretText = "BRWSWDGJUU";
  const path = usercalls();
  const [formData, setFormData] = useState({
    exchange: "",
    apiKey: "",
    secret: "",
    name: "",
    passphrase: "",
    id: "",
  });
  const [savedData, setSavedData] = useState([]);
  const [marketList, setMarketList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState({});
  const [connectLoading, setConnectLoading] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "exchange") {
      const selectedMarket = marketList.find(
        (market) => market.value === value,
      );

      setFormData((prev) => ({
        ...prev,
        exchange: selectedMarket?.label || "",
        market_code: selectedMarket?.value || "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const getMarketList = async () => {
    try {
      const url = `${consts.BackendUrl}/bots/get-markets`;
      const response = await path.postCall({ url });
      const result = await response.json();

      if (result?.success && Array.isArray(result?.result)) {
        const formattedMarkets = result.result.map((market) => ({
          label: market.market_name,
          value: market.market_code,
        }));
        console.log(formattedMarkets, "formattedMarkets");
        setMarketList(formattedMarkets);
      } else {
        setMarketList([]);
      }
    } catch (e) {
      setMarketList([]);
      console.log(e);
    }
  };
  const getExchanges = async () => {
    try {
      const url = `${consts.BackendUrl}/bots/get-api-keys`;
      const response = await path.postCall({ url });
      const result = await response.json();
      if (result?.success) {
        setSavedData(result?.result);
      } else {
        setSavedData([]);
      }
    } catch (e) {
      setSavedData([]);
      console.log(e);
    }
  };
  const handleSubmit = async () => {
    try {
      if (!formData?.market_code) {
        return toast.error("Please select an exchange");
      }

      if (!formData?.apikey?.trim()) {
        return toast.error("API Key is required");
      }

      if (!formData?.secret?.trim()) {
        return toast.error("Security Key is required");
      }

      if (!formData?.name?.trim()) {
        return toast.error("Exchange UserName is required");
      }

      if (formData?.passphrase && !formData.passphrase.trim()) {
        return toast.error("Passphrase cannot be empty");
      }

      setSubmitLoading(true);

      const payload = {
        exchange: formData.exchange,
        apikey: formData.apikey,
        secret: formData.secret,
        name: formData.name,
        passphrase: formData.passphrase,
        market_code: formData.market_code,
        id: formData._id,
      };

      const url = `${consts.BackendUrl}/bots/create-api-key`;

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (!result?.success) {
        toast.error(result?.message);
        return;
      }

      toast.success(result?.message);
      getExchanges();
      setOpenAdd(false);

      setFormData({
        exchange: "",
        apikey: "",
        secret: "",
        name: "",
        passphrase: "",
        market_code: "",
        id: "",
      });

      setEditIndex(null);
    } catch (error) {
      console.error(error);
      toast.error("Cannot add API key");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleEdit = (item, index) => {
    setFormData(item);
    setEditIndex(index);
    setOpenAdd(true);
  };

  const handleDelete = async (id) => {
    setDeleteLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/delete-exchange`;
      const payload = {
        id: id,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message);
        getExchanges();
      } else {
        toast.error(result?.message);
      }
    } catch (e) {
      console.log(e);
      toast.error("Failed to delete exchange");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleVerify = async (id) => {
    setVerifyLoading((prev) => ({ ...prev, [id]: true }));
    try {
      const url = `${consts.BackendUrl}/bots/verifyApikey`;
      const payload = { id: id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message);
        getExchanges();
      } else {
        toast.error(result?.message);
      }
    } catch (e) {
      console.log(e);
      toast.error("Failed to verify API key");
    } finally {
      setVerifyLoading((prev) => ({ ...prev, [id]: false }));
    }
  };
  const handleConnect = async (id) => {
    setConnectLoading((prev) => ({ ...prev, [id]: true }));
    try {
      const url = `${consts.BackendUrl}/bots/add-exchange`;
      const payload = { id: id };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message);
        getExchanges();
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (e) {
      console.log(e);
      toast.error("Failed to connect exchange");
    } finally {
      setConnectLoading((prev) => ({ ...prev, [id]: false }));
    }
  };
  useEffect(() => {
    getExchanges();
    getMarketList();
  }, []);
  return (
    <div className="market-full page_align ar3">
      <Header />
      {savedData.length === 0 ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "100vh" }}
        >
          <Grid item xs={11} sm={8} md={6} lg={4}>
            <div
              style={{
                border: "1px solid #2a2a2a",
                borderRadius: "12px",
                padding: "40px",
                textAlign: "center",
                background: "#0f0f0f",
              }}
            >
              <h2 style={{ marginBottom: "30px" }}>Bot</h2>

              <Button
                variant="contained"
                onClick={() => setOpenAdd(true)}
                style={{
                  padding: "10px 30px",
                  borderRadius: "8px",
                }}
              >
                Add Exchange
              </Button>
            </div>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid container className="mb-20">
            <Grid item xs={12}>
              <div className="support-head bot_dash display-2 mb-20 p-2">
                <div className="bot-heading">Bot</div>

                <div className="bot_comman_btn">
                  <Button onClick={() => setOpenAdd(true)}>Add Exchange</Button>
                </div>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} className="mt-20">
            {savedData.map((item, index) => (
              <Grid item xs={12} sm={12} md={6} lg={6} key={item._id || index}>
                {/* <div className="bot_container contain-width ">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <div className="info_row">
                        <span className="label">Exchange</span>
                        <span className="value">{item.exchange || "----"}</span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div className="info_row">
                        <span className="label">API Key</span>
                        <span className="value">{item.apikey || "----"}</span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div className="info_row">
                        <span className="label">Secret Key</span>
                        <span className="value">{item.secret || "----"}</span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div className="info_row">
                        <span className="label">User Name</span>
                        <span className="value">{item.name || "----"}</span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div className="info_row">
                        <span className="label">Passphrase</span>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <div>
                            {item.passphrase
                              ? show
                                ? item.passphrase
                                : "*".repeat(item.passphrase.length)
                              : "-"}
                          </div>

                          {item.passphrase && (
                            <IconButton
                              size="small"
                              onClick={() => setShow(!show)}
                            >
                              {show ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          )}
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <div className="flexend mb-20">
                        <div className="bot_comman_btn">
                          <Button onClick={() => handleEdit(item, index)}>
                            Edit
                          </Button>
                        </div>

                        <div className="bot_comman_btn">
                          <Button
                            onClick={() => {
                              setDeleteIndex(item._id);
                              setOpenConfirm(true);
                            }}
                          >
                            Delete
                          </Button>
                        </div>

                        <div className="bot_comman_btn green-btn">
                          {!item.verified ? (
                            <Button
                              onClick={() => handleVerify(item._id)}
                              disabled={verifyLoading[item._id]}
                            >
                              {verifyLoading[item._id]
                                ? "Verifying..."
                                : item.verified
                                  ? "Verified"
                                  : "Verify"}
                            </Button>
                          ) : item?.account_id && item?.isConnected ? (
                            <Button
                              onClick={() =>
                                navigate("/botdash", {
                                  state: { id: item._id },
                                })
                              }
                            >
                              View
                            </Button>
                          ) : (
                            <Button
                              onClick={() => handleConnect(item._id)}
                              disabled={connectLoading[item._id]}
                            >
                              {connectLoading[item._id]
                                ? "Connecting..."
                                : "Connect Exchange"}
                            </Button>
                          )}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div> */}
                <div className="bot_container">
                  {/* Header */}

                  {/* Body */}
                  <div className="bot_body">
                    <div className="info_row">
                      <span>Exchange</span>
                      <span className="valuebot ">
                        {item.exchange || "----"}
                      </span>
                    </div>
                    <div className="info_row">
                      <span>API Key</span>
                      <span className="valuebot ">
                        {item.apikey || "----"}
                      </span>{" "}
                    </div>

                    <div className="info_row">
                      <span>Secret Key</span>
                      <span className="valuebot ">
                        {item.secret || "----"}
                      </span>{" "}
                    </div>

                    <div className="info_row">
                      <span>Username</span>
                      <span className="valuebot ">
                        {item.name || "----"}
                      </span>{" "}
                    </div>

                    <div className="info_row pass_row">
                      <span>Passphrase</span>
                      <div className="pass_box">
                        {show
                          ? item.passphrase
                          : "*".repeat(item.passphrase?.length || 0)}
                        <IconButton
                          sx={{ color: "var(--clr-font)" }}
                          size="small"
                          onClick={() => setShow(!show)}
                        >
                          {show ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </div>
                    </div>
                  </div>

                  <div className="bot_footer ">
                    <div className="bot_comman_btn">
                      <Button onClick={() => handleEdit(item, index)}>
                        Edit
                      </Button>
                    </div>

                    <div className="bot_comman_btn">
                      <Button
                        onClick={() => {
                          setDeleteIndex(item._id);
                          setOpenConfirm(true);
                        }}
                      >
                        Delete
                      </Button>
                    </div>

                    <div className="bot_comman_btn green-btn">
                      {!item.verified ? (
                        <Button
                          onClick={() => handleVerify(item._id)}
                          disabled={verifyLoading[item._id]}
                        >
                          {verifyLoading[item._id]
                            ? "Verifying..."
                            : item.verified
                              ? "Verified"
                              : "Verify"}
                        </Button>
                      ) : item?.account_id && item?.isConnected ? (
                        <Button
                          onClick={() =>
                            navigate("/botdash", {
                              state: { id: item._id },
                            })
                          }
                        >
                          View
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleConnect(item._id)}
                          disabled={connectLoading[item._id]}
                        >
                          {connectLoading[item._id]
                            ? "Connecting..."
                            : "Connect Exchange"}
                        </Button>
                      )}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </Grid>
            ))}
          </Grid>
        </>
      )}
      <Modal
        open={openAdd}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Add Exchange</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => setOpenAdd(false)}
            />
          </div>

          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            <FormControl fullWidth className="bot-input" required>
              <InputLabel id="exchange-label">Exchange (required)</InputLabel>

              <Select
                labelId="exchange-label"
                id="exchange"
                name="exchange"
                value={formData?.market_code || ""}
                label="Exchange (required)"
                onChange={handleChange}
                className="bot-select"
                required
              >
                <MenuItem value="">
                  <em>Select Exchange</em>
                </MenuItem>

                {marketList.map((market) => (
                  <MenuItem key={market.value} value={market.value}>
                    {market.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="API Key (required)"
              name="apikey"
              fullWidth
              value={formData.apikey || ""}
              onChange={handleChange}
              className="bot-input"
              required
            />

            <TextField
              label="Security Key (required)"
              name="secret"
              fullWidth
              value={formData.secret || ""}
              onChange={handleChange}
              className="bot-input"
              required
            />

            <TextField
              label="Exchange UserName (required)"
              name="name"
              fullWidth
              value={formData.name || ""}
              onChange={handleChange}
              className="bot-input"
              required
            />

            <TextField
              label="Passphrase (optional)"
              name="passphrase"
              fullWidth
              value={formData.passphrase || ""}
              onChange={handleChange}
              className="bot-input"
            />

            <div className="bot_comman_btn display-3">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={submitLoading}
              >
                {submitLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Box>
        </Box>
      </Modal>{" "}
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={style}>
          <div className="p-20">Are you sure want to delete this bot?</div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  handleDelete(deleteIndex);
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default BotHome;
